import { cn } from '@/lib/utils';

export function PageHeader({ title, description, actions, className }) {
  return (
    <div className={cn('mb-6 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4', className)} data-testid="page-header">
      <div className="pl-16 md:pl-0">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-foreground" data-testid="page-title">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-sm text-muted-foreground" data-testid="page-description">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex gap-2 pl-16 md:pl-0">{actions}</div>}
    </div>
  );
}
